import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  AEInput,
  AEFile,
  AEAutoComplete,
} from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { actionTypes as countriesActionTypes } from "../../../Countries/_redux/slice";
import { actionTypes as categoriesActionTypes } from "../../../Categories/_redux/slice";
import { actionTypes as subCategoriesActionTypes } from "../../../Subcategories/_redux/slice";
import { actionTypes as locationsActionTypes } from "../../../Locations/_redux/slice";
import { actionTypes as skillsActionTypes } from "../../../Skills/_redux/slice";
import { fetchEntities as getCategories } from "../../../Categories/_redux/actions";
import { AEMetadata, UAEMetadata, defaultMeta } from "../../../../../_emywork/AEPagination";
import { localField } from "../../../../../_emywork/helpers/UIHelper";
import { fetchEntities as getCountries } from "../../../Countries/_redux/actions";
import {
  fetchEntities as getSubCategories,
  resetEntities as resetSubcategories,
} from "../../../Subcategories/_redux/actions";
import {
  fetchEntities as getLocations,
  resetEntities as resetLocations,
} from "../../../Locations/_redux/actions";
import {
  fetchEntities as getSkills,
  resetEntities as resetSkills,
} from "../../../Skills/_redux/actions";
import { InputAdornment, TextField } from "@material-ui/core";
import { CURRENCIES } from "../../../../../_emywork/components/Currency";
import { Autocomplete } from "@material-ui/lab";
import LocationField from "../../../../../_metronic/layout/components/fields/LocationField";

export function EditForm({
  entity,
  btnRef,
  saveEntity,
  validationErrors = [],
}) {
  const dispatch = useDispatch();
  const searchSkills = (e) => {

    dispatch(
      getSkills(
        new AEMetadata({}, {}, { search: e.target.value }, [
          "id",
          localField(),
        ]),
        skillsActionTypes.EmyServiceFilter
      )
    );
  };
  const { formatMessage } = useIntl();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity,
    initialErrors: validationErrors,
    validationSchema: Yup.object().shape({
      title: Yup.string()
        .max(70)
        .required(),
      description: Yup.string()
        .min(400)
        .required(),
      // category_id: Yup.number().required(),
      subcategories: Yup.array()
        .min(1)
        .of(Yup.number()),
      // skills: Yup.array().of(Yup.number()),
      images: Yup.array(),
      // country_id: Yup.number(),
      location_id: Yup.number().required(),
      delivery_time: Yup.number().min(0),
      response_time: Yup.number().min(0),
    }),
    onSubmit: (values) => {
      values.skills = values.skills.map((s) => s.id);
      let {
        title,
        description,
        /*category_id,*/ subcategories,
        skills,
        location_id,
        price,
        delivery_time,
        response_time,
        images,
      } = values;
      let entity = {
        user_id,
        title,
        description,
        /*category_id,*/ subcategories,
        skills,
        location_id,
        price,
        delivery_time,
        response_time,
      };
      let files = { emy_service_images: images };
      saveEntity(entity, files);
    },
  });

  const {
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    setValues,
  } = formik;
  const {
    countries,
    categories,
    subcategories,
    skills,
    // locations,
    user_id,
  } = useSelector((state) => {
    const { entities: countries } = state.countries[
      countriesActionTypes.EmyServiceFilter
    ];
    const { entities: categories } = state.categories[
      categoriesActionTypes.EmyServiceFilter
    ];
    const { entities: subcategories } = state.subcategories[
      subCategoriesActionTypes.EmyServiceFilter
    ];
    // const { entities: locations } = state.locations[
    //   locationsActionTypes.EmyServiceFilter
    // ];
    const { entities: skills } = state.skills[
      skillsActionTypes.EmyServiceFilter
    ];

    return {
      countries,
      categories,
      subcategories,
      skills,
      // locations,
      user_id: state.auth.user.id,
    };
  }, shallowEqual);

  useEffect(() => {
    dispatch(
      getCategories(defaultMeta, categoriesActionTypes.EmyServiceFilter)
    );
    dispatch(getCountries(defaultMeta, countriesActionTypes.EmyServiceFilter));
  }, [dispatch]);

  // ------------------ Start Sub Categories
  // useEffect(() => {
  //   if (values.category_id) {
  //     dispatch(
  //       getSubCategories(
  //         new AEMetadata({}, {}, { category_id: values.category_id }, [
  //           "id",
  //           localField(),
  //         ]),
  //         subCategoriesActionTypes.EmyServiceFilter
  //       )
  //     );
  //   } else {
  //     setFieldValue("subcategories", []);
  //     dispatch(resetSubcategories(subCategoriesActionTypes.EmyServiceFilter));
  //   }
  // }, [values.category_id]);

  useEffect(() => {
    if (values.category_id) {
      dispatch(
        getSubCategories(
          new UAEMetadata({}, {}, { category_id: values.category_id }, [
            "id",
            localField(),
          ]),
          subCategoriesActionTypes.EmyServiceFilter
        )
      );
    } else {
      setFieldValue("subcategories", []);
      dispatch(resetSubcategories(subCategoriesActionTypes.EmyServiceFilter));
    }
  }, [values.category_id]);
  // ------------------ End Sub Categories


  useEffect(() => {
    if (values.subcategories) {
      dispatch(
        getSkills(
          new AEMetadata({}, {}, { subcategories: values.subcategories }, [
            "id",
            localField(),
          ]),
          skillsActionTypes.EmyServiceFilter
        )
      );
    } else {
      setFieldValue("skills", []);
      dispatch(resetSkills(skillsActionTypes.EmyServiceFilter));
    }
  }, [values.subcategories]);

  // useEffect(() => {
  //   if (values.country_id) {
  //     dispatch(
  //       getLocations(
  //         new AEMetadata({}, {}, { country_id: values.country_id }, [
  //           "id",
  //           localField(),
  //         ]),
  //         subCategoriesActionTypes.EmyServiceFilter
  //       )
  //     );
  //   } else {
  //     setFieldValue("location_id", undefined);
  //     dispatch(resetLocations(locationsActionTypes.EmyServiceFilter));
  //   }
  // }, [values.country_id]);

  const _props = (name, label, type) => {
    let p = {
      name,
      label,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type) {
      case "autocomplete":
        {
          p.useId = true;
          p.getOptionLabel = (o) => o[localField()];
        }
        break;
    }

    return p;
  };

  return (
    <>
      <div className="form form-label-right">
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEFile
              {..._props("images", "IMAGES")}
              multiple
              accept={"image/*"}
            />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput {..._props("title", "TITLE")} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput
              type={"textarea"}
              rows={10}
              {..._props("description", "DESCRIPTION")}
            />
            <small>
              {formatMessage(
                { id: "VALIDATION.TEXT.LENGTH" },
                { value: values.description.length }
              )}
            </small>
          </div>
        </div>

        <div className="form-group row py-1">
          <div className={`col-lg-${values.category_id ? "6" : "12"}`}>
            <AEAutoComplete
              {..._props("category_id", "CATEGORY", "autocomplete")}
              options={categories}
            />
          </div>
          {values.category_id && (
            <div className={`col-lg-6`}>
              <AEAutoComplete
                {..._props("subcategories", "SUBCATEGORY", "autocomplete")}
                options={subcategories}
                multiple
                disabled={!values.category_id}
              />
            </div>
          )}
        </div>
        {values.subcategories.length > 0 && (
          <div className="form-group row py-1">
            <div className={`col-lg-12`}>
              {/* <AEAutoComplete
                {..._props("skills", "SKILLS", "autocomplete")}
                options={skills}
                multiple
              /> */}
              {/* TODO: refactor to reusable component*/}
              <Autocomplete
                name="skills"
                options={skills}
                value={formik.values.skills}
                getOptionLabel={(o) => o[localField()]}
                multiple
                onChange={(e, v) => {

                  setFieldValue("skills", v);
                }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Skills"
                    placeholder="Skills"
                    onChange={(e) => searchSkills(e)}
                    className="bg-white rounded"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>
        )}
        <div className="form-group d-lg-flex py-1">
          <div className={`flex-lg-fill px-2`}>
            <AEAutoComplete
              {..._props("country_id", "COUNTRY", "autocomplete")}
              options={countries}
              validation={false}
            />
          </div>
          {values.country_id && (
            <div className={`flex-lg-fill px-2`}>
              {/* <AEAutoComplete
                {..._props("location_id", "LOCATION", "autocomplete")}
                options={locations}
              /> */}

              <LocationField
                dispatch={dispatch}
                setFieldValue={setFieldValue}
                className="bg-white rounded"
                dispatchedAction={"ProjectFilter"}
                variant="outlined"
              />
            </div>
          )}
        </div>
        <div className="form-group d-lg-flex py-1">
          <div className="flex-fill pr-2">
            <AEInput
              {..._props("price", "PRICE")}
              type={"number"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {CURRENCIES.MAD}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="flex-fill pr-2">
            <AEInput
              {..._props("delivery_time", "DELIVERY_TIME")}
              type={"number"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {formatMessage({ id: "MINUTES" })}
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="flex-fill pr-2">
            <AEInput
              {..._props("response_time", "RESPONSE_TIME")}
              type={"number"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {formatMessage({ id: "MINUTES" })}
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </div>

        <button
          style={{ display: "none" }}
          ref={btnRef}
          onClick={() => {
            handleSubmit();
          }}
        />
      </div>
    </>
  );
}
